<template>
    <div class="flex mt-8 md:mt-12 flex-col mx-4 md:mx-0">
        <!-- <ButtonWhite :text="translations.back_button_last_page" @click="$emit('back')" class="mb-6" /> -->
        <!-- <Button :text="translations.continue_shopping"/> -->
    </div>
</template>

<script>
export default {
    props: ['translations'],
}
</script>
